import React, { useMemo } from 'react';
import clsx from 'clsx';
import { slugify } from 'utils/helpers';

const OptionValue = ({ option, optionId, selectedOption, value, selectedOptions, variants, onChange }) => {
  const selectedItemOptions = selectedOptions.map((o) => (o.name === option.name ? { name: option.name, value } : o));
  const newVariant = variants.find((v) => JSON.stringify(v.selectedOptions) === JSON.stringify(selectedItemOptions));

  const swatchClass = window.availableColors?.find((swatch) => slugify(swatch.name) === slugify(value))
    ? `swatch--${slugify(value)}`
    : 'swatch--fallback';

  const isOOS = useMemo(
    () => variants.every(({ availableForSale, inventoryQuantity }) => !availableForSale && inventoryQuantity < 10),
    [newVariant, option, value, variants],
  );

  return (
    <label
      key={`${optionId}-${value}`}
      htmlFor={`${optionId}-${slugify(value)}`}
      className={`swatch relative flex size-7.5 cursor-pointer items-center justify-center ${swatchClass}`}
    >
      <input
        type="radio"
        id={`${optionId}-${slugify(value)}`}
        name={`${optionId}-${option.name}`}
        value={value}
        checked={selectedOption?.value === value}
        onChange={(e) => onChange(option, e.target.value)}
        className={clsx('peer size-7 cursor-pointer border-0 !ring-0 checked:size-6 checked:bg-none', {
          unavailable: isOOS,
        })}
      />
      <div
        className={clsx(
          'swatch__outline transition-[color, opacity] absolute inset-0 rounded-full border opacity-0 duration-200 peer-checked:opacity-100',
          { '!border-black hover:!border-brand-tangerine': selectedOption?.value === value },
        )}
      ></div>
      <span className={`sr-only`}>{value}</span>
      {isOOS && <div className="0 absolute left-4 -ml-px h-10.5 w-px rotate-45 bg-grey-dark"></div>}
    </label>
  );
};
const SwatchOption = ({ option, selectedOptions, ...props }) => {
  const optionId = `product-option-${option.name}`;

  const selectedOption = useMemo(() => selectedOptions.find((o) => o.name === option.name), [selectedOptions, option]);

  return (
    <div>
      <label
        htmlFor={optionId}
        className="body-2 mb-2 block"
      >
        {option.name}: {!!selectedOption?.value && <span className="body-2-bold">{selectedOption.value}</span>}
      </label>

      <div
        id={optionId}
        name={optionId}
        className="flex flex-wrap gap-3 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
        data-option-name={option.name}
      >
        {option.values.map((value) => (
          <OptionValue
            key={value}
            option={option}
            value={value}
            selectedOptions={selectedOptions}
            selectedOption={selectedOption}
            optionId={optionId}
            {...props}
          />
        ))}
      </div>
    </div>
  );
};

export default SwatchOption;
